import Firebase from 'firebase'

let config = {
  apiKey: 'AIzaSyAkHACuvyfiRldAG80-vTt38sekErJ21yk',
  authDomain: 'pei-exchange.firebaseapp.com',
  databaseURL: 'https://pei-exchange.firebaseio.com',
  storageBucket: 'pei-exchange.appspot.com',
  messagingSenderId: '999718301926'
}

let app = Firebase.initializeApp(config)
let db = app.database()
let storage = app.storage().ref()
let auth = app.auth()

export { app, db, storage, auth }



// WEBPACK FOOTER //
// ./src/firebase/index.js